<template>
  <CompensatoryServiceHistory
    :get-compensatory-request-student-service="
      getCompensatoryRequestStudentService
    "
    :get-status-history="getStatusHistory"
    :request-service-data="serviceData"
  />
</template>

<script>
import { CompensatoryServiceHistory } from 'compensatory-service';
import {
  getStatusHistory as _getStatusHistory,
  getCompensatoryRequestStudentService as _getCompensatoryRequestStudentService,
  getEducationalCompensatoryRequest as _getEducationalCompensatoryRequest,
} from '@/modules/compensatoryService/api';

export default {
  components: {
    CompensatoryServiceHistory,
  },
  data() {
    return {
      serviceData: null,
    };
  },
  mounted() {},
  methods: {
    getCompensatoryRequestStudentService() {
      this.serviceData = this.serviceData = this.$route.params;
      if (this.$route.query.isEducational) {
        return _getEducationalCompensatoryRequest(this.$route.params.requestId);
      }

      return _getCompensatoryRequestStudentService({
        requestId: this.$route.params.requestId,
        studentServiceId: this.$route.params.studentServiceId,
      });
    },
    getStatusHistory(requestId, pageSize = 10, currentPage = 1) {
      const isEducational = this.$route.query.isEducational;
      return _getStatusHistory(requestId, pageSize, currentPage, isEducational);
    },
  },
};
</script>
